import React from 'react';
import { Container, Button } from 'Components/core';
import { ApiStore, Subscribe } from 'Store';

import InfoBox from 'Components/InfoBox';

import readyToEnroll from './images/ready-to-enroll.jpg';

export default class ReadyToEnroll extends React.Component {
  render() {
    return (
      <Subscribe to={[ApiStore]}>
        {state => { 
          if(!(state.oeMaterials.enrollText || state.oeMaterials.enrollURL))
          {
            return null;
          }
          
          return  (
            <InfoBox image={readyToEnroll} header="Ready to enroll?">
              <Container seperation="16px" column>
                {state?.oeMaterials?.enrollText ? (
                  <p dangerouslySetInnerHTML={{__html:state.oeMaterials.enrollText}} ></p>
                ) :''}
                {typeof state.oeMaterials?.enrollURL === 'string' && (
                  <Button to={state.oeMaterials.enrollURL}>Sign Up Today</Button>
                )}
              </Container>
            </InfoBox>
          );}}
      </Subscribe>
    );
  }
}
